import { ApplicationInsights } from '@microsoft/applicationinsights-web';

let appInsights: ApplicationInsights | null = null;

export function initAppInsights() {
    if (!appInsights) {
        appInsights = new ApplicationInsights({
            config: {
                connectionString:
                    'InstrumentationKey=83cb49fb-2453-4180-bb34-cc5772d91e75;IngestionEndpoint=https://uksouth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://uksouth.livediagnostics.monitor.azure.com/;ApplicationId=9a4a6b4b-2df6-4f1c-8e2b-51e3d08dcc08',
                enableAutoRouteTracking: true,
                disableFetchTracking: false,
                enableAjaxErrorStatusText: true
            }
        });

        appInsights.loadAppInsights();
    }
}

export function trackTrace(message: string, properties?: Record<string, any>) {
    appInsights?.trackTrace({
        message,
        properties
    });
}

export function trackEvent(name: string, properties?: Record<string, any>) {
    appInsights?.trackEvent({
        name,
        properties
    });
}

export function trackException(error: Error, properties?: Record<string, any>) {
    appInsights?.trackException({
        exception: error,
        properties
    });
}
